

























import Vue, {PropType} from 'vue'
import {Column} from "@/components/table/types";

export default Vue.extend({
    name: 'LinkTable',
    props: {
        column: {
            type: Object as PropType<Column>
        },
        value: {
            type: [String, Number],
            required: true,
            default: ''
        },
        nRow: {
            type: Number,
        },
        nColumn: {
            type: Number,
        },
        screen: {
            type: String,
            default:null
        },
    },
    methods: {},
    data: function () {
        return {
        }
    }
})
